import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListingSortComponentDef } from '@df/catalog-ui/listing/sort/listing-sort.component.def';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'listing-sort',
    templateUrl: './listing-sort.html',
    standalone: true,
    imports: [SizeClassDirective, TranslationModule, OffClickModule, NgStyle, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSortComponent extends ListingSortComponentDef {}
